import { useEffect } from 'react';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../../services/AuthConfig';
import { TfiMicrosoftAlt } from "react-icons/tfi";
import bayerLogo from '../../imgs/Logo_Bayer.png';
import dtitLogo from '../../imgs/Logo_DTIT.png';
import miaLogo from '../../imgs/Logo_MIA.png';
import './Login.css';

function Login() {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  const handleMicrosoftLogin = async () => {
    try {
      await instance.loginRedirect({
        ...loginRequest,
        prompt: 'select_account' // Permite selecionar conta se houver múltiplas
      });
    } catch (error) {
      console.error('Erro durante o login:', error);
    }
  };

  // Redireciona automaticamente se já estiver autenticado
  useEffect(() => {
    if (accounts.length > 0) {
      navigate('/'); 
    }
  }, [accounts, navigate]);

  return (
    <div className="login-container">
      <AuthenticatedTemplate>
        <div className="login-card">
          <div className="logo-container">
            <img src={dtitLogo} alt="DT&IT Logo" className="company-logo" />
            <img src={bayerLogo} alt="Bayer Logo" className="company-logo" />
          </div>
          
          <div className="jarvis-logo-container">
            <img src={miaLogo} alt="Jarvis Logo" className="jarvis-logo" />
            <h1>MIA Content</h1>
          </div>

          <div className="login-content">
            <h2>Login realizado com sucesso!</h2>
            <p>Redirecionando para o painel principal...</p>
            <button 
              className="microsoft-login-button" 
              onClick={() => navigate('/')}
            >
              Continuar para a MIA
            </button>
          </div>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="login-card">
          <div className="logo-container">
            <img src={dtitLogo} alt="DT&IT Logo" className="company-logo" />
            <img src={bayerLogo} alt="Bayer Logo" className="company-logo" />
          </div>
          
          <div className="jarvis-logo-container">
            <img src={miaLogo} alt="Jarvis Logo" className="jarvis-logo" />
            <h1>MIA Content</h1>
          </div>

          <div className="login-content">
            <button className="microsoft-login-button" onClick={handleMicrosoftLogin}>
              <TfiMicrosoftAlt />
              Sign in with Microsoft
            </button>

          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default Login;